// extracted by mini-css-extract-plugin
module.exports = {"compact":"style_compact__HBRTu","compact__expanded":"style_compact__expanded___x5yM"};